/* AFORCH — motion + UI (defer-load). No dependencies. */
(function(){
  function onReady(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  onReady(function(){
    var root = document.querySelector('.af') || document.body;

    /* mobile navigation */
    var menuToggle = root.querySelector('[data-af-menu-toggle]');
    var mobileMenu = root.querySelector('[data-af-mobile-menu]');
    if(menuToggle && mobileMenu){
      menuToggle.addEventListener('click',function(){
        var open = mobileMenu.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded',String(open));
        mobileMenu.setAttribute('aria-hidden',String(!open));
      });
      mobileMenu.querySelectorAll('a').forEach(function(link){
        link.addEventListener('click',function(){
          mobileMenu.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded','false');
          mobileMenu.setAttribute('aria-hidden','true');
        });
      });
    }

    /* scroll reveal (stagger siblings) */
    var items = Array.prototype.slice.call(root.querySelectorAll('.rv,.rv-l,.rv-r,.rv-s,.clip-up'));
    items.forEach(function(el){
      var sibs = Array.prototype.slice.call(el.parentElement.children).filter(function(c){return /(^|\s)(rv|rv-l|rv-r|rv-s|clip-up)(\s|$)/.test(c.className||'');});
      var i = sibs.indexOf(el);
      if(i>0) el.style.transitionDelay = (i*0.08)+'s';
    });
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:0.12,rootMargin:'0px 0px -6% 0px'});
    items.forEach(function(el){ io.observe(el); });
    requestAnimationFrame(function(){ items.forEach(function(el){ if(el.getBoundingClientRect().top < window.innerHeight*0.92) el.classList.add('in'); }); });

    /* count-up */
    function count(el){
      var to=parseFloat(el.getAttribute('data-to')||'0'), suf=el.getAttribute('data-suffix')||'', dur=1600, start=performance.now();
      function fmt(n){ return to>=1000 ? Math.floor(n).toLocaleString('en-US') : Math.floor(n); }
      function step(t){ var p=Math.min((t-start)/dur,1), e=1-Math.pow(1-p,3); el.textContent=fmt(to*e)+suf; if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    var cnts = Array.prototype.slice.call(root.querySelectorAll('.cnt'));
    var cio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ count(e.target); cio.unobserve(e.target);} }); },{threshold:0.5});
    cnts.forEach(function(el){ cio.observe(el); });

    /* transparent -> solid nav + parallax */
    var nav = root.querySelector('.af-nav:not(.static)');
    var pxs = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
    var heroContent = root.querySelector('[data-hero-content]');

    /* hero motion: floating droplets (only if motion bg present) */
    var dropHost = root.querySelector('[data-droplets]');
    if(dropHost){
      var N = 18;
      for(var i=0;i<N;i++){
        var d = document.createElement('span');
        d.className = 'af-drop';
        var sz = 4 + Math.random()*6;
        d.style.width = sz+'px'; d.style.height = sz+'px';
        d.style.left = (Math.random()*100)+'%';
        d.style.animation = 'afDrop '+(8+Math.random()*10)+'s linear '+(Math.random()*-12)+'s infinite';
        d.style.opacity = String(0.3+Math.random()*0.4);
        dropHost.appendChild(d);
      }
      /* pause animation when offscreen for perf */
      var mo = new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.style.animationPlayState = e.isIntersecting ? 'running':'paused'; }); },{threshold:0});
      mo.observe(dropHost);
    }
    /* Must exist before frame() runs: frame drives the leaf-divider sway. */
    var ldHostsAll = [];
    var ticking=false;
    var lastScroll=window.scrollY, lastT=performance.now(), scrollVel=0;
    function frame(){
      ticking=false;
      var y=window.scrollY;
      var now=performance.now();
      var dt=Math.max(now-lastT,1);
      scrollVel = (y-lastScroll)/dt; /* px per ms */
      lastScroll=y; lastT=now;
      if(nav) nav.classList.toggle('solid', y > window.innerHeight*0.72);
      if(heroContent){ var p=Math.min(y/(window.innerHeight*0.8),1); heroContent.style.transform='translateY('+(y*0.18)+'px)'; heroContent.style.opacity=String(1-p*0.85); }
      pxs.forEach(function(el){
        var f=parseFloat(el.getAttribute('data-parallax'))||0.15;
        var r=el.parentElement.getBoundingClientRect();
        var off=(r.top + r.height/2 - window.innerHeight/2) * -f;
        el.style.transform='translateY('+off+'px)';
      });
      /* leaf-divider: scroll-driven sway on top of CSS idle sway */
      ldHostsAll.forEach(function(host){
        if(!host._leaves) return;
        var rect = host.getBoundingClientRect();
        if(rect.bottom < -200 || rect.top > window.innerHeight+200) return;
        /* progress: -1 (below) → 0 (centered) → 1 (above) */
        var prog = (window.innerHeight/2 - (rect.top + rect.height/2)) / (window.innerHeight/2);
        var v = Math.max(-1, Math.min(1, prog));
        var velBoost = Math.max(-3, Math.min(3, scrollVel*0.6));
        host._leaves.forEach(function(lf, idx){
          var wind = Math.sin(v*Math.PI + lf.phase) * 8 + velBoost*2;
          var tilt = lf.baseRot + wind;
          var lift = Math.abs(wind)*0.4;
          lf.el.style.setProperty('--af-sway-rot', tilt.toFixed(2)+'deg');
          lf.el.style.setProperty('--af-sway-y', (-lift).toFixed(2)+'px');
        });
      });
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    frame();

    /* leaf-divider: populate leaves + scroll-driven sway */
    /* expose as global so sections loaded later (theme editor / lazy) can init */
    function initLeafHost(host){
      if(host._leafInit) return; host._leafInit = true;
      var dir = host.getAttribute('data-direction')||'ltr';
      var image = host.querySelector('.af-leafdiv-image');
      if(image){
        host._leaves = [{el:image, x:0, y:0, baseRot:0, phase:0}];
        ldHostsAll.push(host);
        var imageObserver = new IntersectionObserver(function(es){
          es.forEach(function(e){ host.classList.toggle('in-view', e.isIntersecting); });
        },{threshold:0});
        imageObserver.observe(host);
        return;
      }
      var density = parseInt(host.getAttribute('data-density')||'8',10);
      var grp = host.querySelector('[data-leaf-grp]');
      if(!grp) return; 
      var leafIds = ['af-leaf-a','af-leaf-b','af-leaf-c','af-leaf-d','af-leaf-e'];
      var leaves = [];
      for(var i=0;i<density;i++){ 
        var t = density===1 ? 0.5 : i/(density-1);
        var jx = (Math.random()-0.5)*30;
        var jy = (Math.random()-0.5)*16;
        var x = dir==='rtl' ? (940 - t*880 + jx) : (60 + t*880 + jx);
        var y = 60 + t*200 + jy;
        var sz = 60 + Math.random()*60 + (1-t)*20;
        var sym = leafIds[i % leafIds.length];
        var rot0 = (Math.random()-0.5)*40;
        var delay = (Math.random()*-6).toFixed(2);
        var dur = (5 + Math.random()*4).toFixed(2);
        var ns = 'http://www.w3.org/2000/svg';
        var use = document.createElementNS(ns,'use');
        use.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href','#'+sym);
        use.setAttribute('href','#'+sym);
        use.setAttribute('x', (x-sz/2).toFixed(1));
        use.setAttribute('y', (y-sz).toFixed(1));
        use.setAttribute('width', sz.toFixed(1));
        use.setAttribute('height', (sz*1.6).toFixed(1));
        use.setAttribute('data-base-rot', rot0.toFixed(2));
        use.style.transformOrigin = (x).toFixed(1)+'px '+(y).toFixed(1)+'px';
        use.style.animation = 'afLeafSway '+dur+'s ease-in-out '+delay+'s infinite';
        var bright = (0.82 + t*0.45).toFixed(2);
        var sat = (1.15 - t*0.25).toFixed(2);
        use.style.filter = 'brightness('+bright+') saturate('+sat+')';
        grp.appendChild(use);
        leaves.push({el:use, x:x, y:y, baseRot:rot0, phase:Math.random()*Math.PI*2});
      }
      host._leaves = leaves;
      ldHostsAll.push(host);
      /* toggle in-view class for scroll-driven animation */
      var lio = new IntersectionObserver(function(es){
        es.forEach(function(e){ host.classList.toggle('in-view', e.isIntersecting); });
      },{threshold:0});
      lio.observe(host);
    }
    window.AFORCH_initLeafDivider = initLeafHost;
    Array.prototype.slice.call(root.querySelectorAll('[data-leafdiv]')).forEach(initLeafHost);

    /* product-detail: qty + variant price (progressive) */
    var pd = root.querySelector('[data-pd]');
    if(pd){
      var qEl=pd.querySelector('[data-qty]'), totEl=pd.querySelector('[data-total]');
      var qty=1, price=parseFloat(pd.getAttribute('data-price')||'0');
      function render(){ if(qEl)qEl.textContent=qty; if(totEl)totEl.textContent=(price*qty).toLocaleString('en-US'); }
      pd.addEventListener('click',function(e){
        var t=e.target.closest('[data-act]'); if(!t)return;
        var a=t.getAttribute('data-act');
        if(a==='inc') qty++;
        if(a==='dec') qty=Math.max(1,qty-1);
        if(a==='size'){ price=parseFloat(t.getAttribute('data-price')||price); pd.querySelectorAll('[data-act="size"]').forEach(function(s){s.classList.remove('sel');}); t.classList.add('sel'); }
        if(a==='thumb'){ var m=pd.querySelector('[data-main]'); if(m)m.src=t.getAttribute('data-src'); pd.querySelectorAll('[data-act="thumb"]').forEach(function(s){s.classList.remove('sel');}); t.classList.add('sel'); }
        render();
      });
      render();
    }
  });
})();
